export enum ExportOption {
    transposeValues = "transposeValues",
    addComments = "addComments",
    exportStatus = "exportStatus",
    exportAllValueTypes = "exportAllValueTypes",
    replaceValuesOf = "replaceValuesOf",
}

interface IExportOptionProperties {
    label: string
}

export const ExportOptionProperties: {
    [key in ExportOption]: IExportOptionProperties
} = {
    [ExportOption.transposeValues]: {
        label: "Transpose Values",
    },
    [ExportOption.addComments]: {
        label: "Add comments to Excel files",
    },
    [ExportOption.exportStatus]: {
        label: "Export Status Information",
    },
    [ExportOption.exportAllValueTypes]: {
        label: "Export all types of values at once",
    },
    [ExportOption.replaceValuesOf]: {
        label: "Replace values of status with",
    },
}

export const getLabel = (exportOption: ExportOption): string => {
    return ExportOptionProperties[exportOption].label
}
